import { ConsentService } from '../../../services/ConsentService';

export const isMissingConsent = (consentService?: ConsentService) => !consentService?.hasConsent()
  || !consentService?.isSigned();
